import { useEffect } from 'react';
import { Outlet, useLocation, useNavigationType } from 'react-router-dom';
import { Header } from '../components/landing/Header';
import { Footer } from '../components/landing/Footer';

/**
 * Client-side navigation keeps the previous page's scroll position, so a link clicked near the
 * bottom of one page would open the next page at its bottom. Start each new page at the top,
 * except on back/forward (the browser restores that position) and for #anchor links (the page
 * scrolls to its own anchor).
 */
function useScrollToTopOnNavigate(): void {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP' || hash) return;
    // 'instant' overrides the site's smooth scroll-behavior, so the new page doesn't visibly scroll up.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash, navigationType]);
}

export function MarketingLayout(): JSX.Element {
  useScrollToTopOnNavigate();

  return (
    <div className="min-h-screen bg-[var(--landing-bg)] text-[var(--landing-text-primary)]">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
